import { useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, onSnapshot } from 'firebase/firestore';
import { auth, db } from '../firebase';
import { ensureUserProfile } from '../lib/auth';

export function useSession() {
  const [user, setUser] = useState(undefined);
  const [profile, setProfile] = useState(null);
  const [profileLoading, setProfileLoading] = useState(true);

  useEffect(() => {
    let unsubProfile = () => {};
    const unsubAuth = onAuthStateChanged(auth, async (next) => {
      unsubProfile();
      setUser(next || null);
      if (!next) {
        setProfile(null);
        setProfileLoading(false);
        return;
      }
      setProfileLoading(true);
      try {
        await ensureUserProfile(next);
      } catch {
        // profile ensure is best-effort; snapshot still loads
      }
      unsubProfile = onSnapshot(
        doc(db, 'users', next.uid),
        (snap) => {
          setProfile(snap.exists() ? { uid: snap.id, ...snap.data() } : null);
          setProfileLoading(false);
        },
        () => {
          setProfile(null);
          setProfileLoading(false);
        },
      );
    });
    return () => {
      unsubAuth();
      unsubProfile();
    };
  }, []);

  const needsOnboarding =
    Boolean(user) &&
    !profileLoading &&
    profile &&
    profile.onboardingComplete !== true;

  const isBlocked = profile?.accountStatus === 'blocked';

  return {
    user,
    profile,
    profileLoading,
    loading: user === undefined || (user && profileLoading),
    needsOnboarding,
    isBlocked,
  };
}
